import {AnnouncementItems} from '../consts/types';
import {getVersion} from '../../../services/xpertService';
import {isDevEnv} from '../../../utils/platform';
import {priSupprtUrl, verReleaseNotesEn, verReleaseNotesHe} from '../consts/consts';

export const checkIsWelcome = (announcement: AnnouncementItems) => {
    return announcement.type === 'Welcome';
};

export const getWelcomePage = (announcements: AnnouncementItems[]) => {
    if (checkIsWelcome(announcements[0])) {
        return announcements[0];
    }
    return null;
};

export const getAnnouncements = (announcements: AnnouncementItems[]) => {
    if (checkIsWelcome(announcements[0])) {
        return announcements.slice(1);
    }
    return announcements;
};

export const getPriorityVeriosn = () => {
    const version = getVersion();
    return isDevEnv() ? '25.00' : version;
};

export const getAnnouncementsShowMoreLink = isRtl => {
    let url = priSupprtUrl;
    const version = getPriorityVeriosn();
    switch (version) {
        case '25.01':
            return isRtl ? (url += verReleaseNotesHe) : (url += verReleaseNotesEn);

        default:
            return url;
    }
};
